import styled from 'styled-components';

import Box from '../components/layout/Box';

const StyledBox = styled(Box)`
  flex-direction: column;
  margin-top: 64px;
  flex-grow: 1;
`;

const ScrollContainer = ({ children }) => {
  return (
    <StyledBox
      className="scrollContainer"
      style={{
        overflowY: 'scroll',
      }}
    >
      {children}
    </StyledBox>
  );
};

export default ScrollContainer;
